import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { DescriptionListProvider } from './DescriptionList.Context/provider.es.js';
import { DescriptionListDescription } from './DescriptionList.Description/DescriptionList.Description.es.js';
import { DescriptionListLabel } from './DescriptionList.Label/DescriptionList.Label.es.js';

const DescriptionList = ({ className, children, density = 'default', size = 'base', ...rest })=>{
    return jsx(DescriptionListProvider, {
        density: density,
        size: size,
        children: jsx("dl", {
            className: classNames('cb-description-list columns', className),
            "data-testid": "description-list",
            ...rest,
            children: children
        })
    });
};
DescriptionList.displayName = 'DescriptionList';
DescriptionList.Label = DescriptionListLabel;
DescriptionList.Description = DescriptionListDescription;

export { DescriptionList, DescriptionList as default };
//# sourceMappingURL=DescriptionList.es.js.map
